import {
  Component,
  OnInit,
  Input
} from '@angular/core';

@Component({
  selector: "secondary-values",
  templateUrl: "./secondary-values.component.html",
  styleUrls: ["./secondary-values.component.scss"]
})
export class SecondaryValuesComponent implements OnInit {
  @Input() secondaryElement: any;
  @Input() productTypeCode: string;
  math = Math;
  constructor() {}
  ngOnInit() {}
}
